import {useMemo} from 'react'
import {ProductDataType} from '@/types/product'

interface UseMemoizedProductDataParams {
    isDataLoading: boolean
    resultCount: number
    productResults: Array<{
        data: {
            image_url?: string
            averageRating?: number
            totalReviews?: number
            url?: string
            id: string
            variation_id?: string
        }
        value?: string
    }>
    sfccProducts: ProductDataType[]
}

export interface ProductLoadingReturn {
    skeleton: boolean
    id: string
}

export const useMemoizedProductData = ({
    isDataLoading,
    resultCount,
    productResults,
    sfccProducts
}: UseMemoizedProductDataParams): ProductLoadingReturn[] | ProductDataType[] => {
    return useMemo(() => {
        if (isDataLoading) {
            return Array.from({length: resultCount}, (_, i) => ({
                skeleton: true,
                id: `skeleton-${i}`
            }))
        } else {
            return productResults?.map((item) => {
                const {
                    data: {image_url, averageRating, totalReviews, url, id, variation_id},
                    value
                } = item
                const sfccProduct = sfccProducts?.find((p: ProductDataType) => p.id === id)
                const sfccPriceBook = sfccProduct?.c_priceInfo?.priceInfo || null
                return {
                    ...sfccProduct,
                    skeleton: false,
                    id,
                    image_url: image_url,
                    name: value,
                    number_of_reviews: totalReviews,
                    rating: sfccProduct?.rating ?? averageRating,
                    url,
                    variation_id,
                    price: sfccPriceBook,
                    inventory: sfccProduct?.inventory,
                    type: sfccProduct?.type ?? 'default',
                    imageGroups: sfccProduct?.imageGroups ?? []
                }
            })
        }
    }, [isDataLoading, resultCount, productResults, sfccProducts])
}
